export const HIERARCHY_CHANGE = 'change:hierarchy';
export const HIERARCHY_RESET = 'reset:hierarchy';
